import { Outlet } from "react-router-dom";
import { FullHeightLayout } from "./AuthLayout.styles";
import { useEffect } from "react";
import httpClient from "../../../api/httpClient";
import { ROUTES } from "../../../constant/routes";
import LogoImage from "../../../assets/images/logo.png";

const AuthLayout = () => {
  const acesstoken = httpClient.getAccessToken();

  useEffect(() => {
    if (acesstoken) window.location.href = ROUTES.DASHBOARD;
  }, [acesstoken]);

  return (
    <>
      {!acesstoken && (
        <FullHeightLayout>
          <div className={`card-div`}>
            <div className="auth-left">
              <div className="left-top">
                <div className="logo-wrap">
                  <img src={LogoImage} alt="Kelu Logo" />
                  <div className="brand-name">
                    Kelu
                    <span>Customer App</span>
                  </div>
                </div>

                <h1 className="sub-title">
                  One Place for Everything With Your Business
                </h1>

                <div className="accent-line" />

                <p className="left-desc">
                  Message your business, join meetings, track requests, share
                  documents and get updates  all from one secure app.
                </p>
              </div>

              <div className="left-bottom">
                <div className="feature-pills">
                  <div className="pill">
                    <div className="pill-icon">💬</div>
                    <div className="pill-text">
                      Conversations
                      <span>Message your business securely</span>
                    </div>
                  </div>

                  <div className="pill">
                    <div className="pill-icon">📹</div>
                    <div className="pill-text">
                      Meetings & Documents
                      <span>Join calls and share files in one place</span>
                    </div>
                  </div>

                  <div className="pill">
                    <div className="pill-icon">📋</div>
                    <div className="pill-text">
                      Requests & Updates
                      <span>Track everything and stay informed</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Outlet />
          </div>
        </FullHeightLayout>
      )}
    </>
  );
};

export default AuthLayout;
